<div id='status-root'>
  <div class="unification-status-chip" [ngClass]="toKebabCase(status!)">
              <div class="chip-icon">
                <mat-icon *ngIf="status === 'unified'">check_circle_outline</mat-icon>
                <mat-icon *ngIf="status === 'scheduled'">hourglass_bottom</mat-icon>
                <mat-icon *ngIf="status === 'rejected'">error_outline</mat-icon>
                <mat-icon *ngIf="status === 'pending'">pause</mat-icon>
                <mat-icon *ngIf="status === 'in_progress'">update</mat-icon>
              </div>
              <div class="chip-label">
                {{this.capitalizeFirstLetter(status!)}}
              </div>
            </div>
</div>
